export function clx(...classes: string[]): string {
  return classes.join(' ');
}
